module.exports = __webpack_public_path__ + "static/media/route-board.2a0711b4.svg";